import { createContext, ReactNode, useContext, useMemo } from 'react';

import { fetchIconList } from '../api/calls/fetchIconList';
import { fetchIconSvg } from '../api/calls/fetchIconSvg';
import { fetchIconVariations } from '../api/calls/fetchIconVariations';
import { useConfig } from './Config';

const ApiContext = createContext<
  | {
      fetchIconList: () => Promise<ApiIconListResponse>;
      fetchIconSvg: (_url: string) => Promise<ApiIconSvgResponse>;
      fetchIconVariations: (_iconId: number) => Promise<ApiIconVariationsResponse>;
    }
  | undefined
>(undefined);

type ApiProviderProps = {
  children: ReactNode;
};

function ApiProvider({ children }: ApiProviderProps) {
  const { realm } = useConfig();
  const value = useMemo(
    () => ({
      fetchIconList: () => fetchIconList(realm),
      fetchIconSvg,
      fetchIconVariations,
    }),
    [realm],
  );
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

function useApi() {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error(`useApi must be used within a ApiProvider`);
  }
  return context;
}

export { ApiProvider, useApi };
